import { render, staticRenderFns } from "./is_plug.bak.vue?vue&type=template&id=01c9c127&scoped=true"
import script from "./is_plug.bak.vue?vue&type=script&lang=js"
export * from "./is_plug.bak.vue?vue&type=script&lang=js"
import style0 from "./is_plug.bak.vue?vue&type=style&index=0&id=01c9c127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9c127",
  null
  
)

export default component.exports